import { Box, ImageNew as Image } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { SvgImage } from '../../../comps/SvgImage'
import { Colors } from '../../../util/util'
import { logoTypes } from './LogoTypes'

interface LogoProps {
  hide?: boolean
  fallbackImageName?: any
  logo: string
  type?: keyof typeof logoTypes | Array<keyof typeof logoTypes>
}

export type LogoTypesOptions = keyof typeof logoTypes
export const LogoTypesOptionArray = Object.keys(logoTypes)

const Logo = (props: LogoProps) => {
  const { hide = false, logo, type = logoTypes.huge } = props

  const [showPlaceHolder, setShowPlaceHolder] = useState(true)
  useEffect(() => {
    setShowPlaceHolder(!logo || logo === '')
  }, [logo])
  if (hide) {
    return null
  }
  const onError = () => {
    setShowPlaceHolder(true)
  }

  return (
    <Box {...logoTypes[type as keyof typeof logoTypes].topContainerStyle} testID="logoBox">
      {!showPlaceHolder && (
        <Box {...logoTypes[type as keyof typeof logoTypes].containerLogo}>
          <Image
            {...logoTypes[type as keyof typeof logoTypes].logo}
            source={logo}
            resizeMode="center"
            onError={onError}
          />
        </Box>
      )}
      {showPlaceHolder && (
        <Box {...logoTypes[type as keyof typeof logoTypes].containerLogo}>
          {/* show category icon as a fallback image */}
          <SvgImage color={Colors.SECONDARY} imageName={props?.fallbackImageName} />
        </Box>
      )}
    </Box>
  )
}

export { Logo }
